import { remarkProseMirror } from "@handlewithcare/remark-prosemirror";
import { type Yaml } from "mdast";
import { type Node as PmNode } from "prosemirror-model";
import remarkFrontmatter from "remark-frontmatter";
import remarkParse from "remark-parse";
import remarkStringify from "remark-stringify";
import { unified } from "unified";
import { stringify } from "yaml";

import { remarkArbitraryListDepth } from "./arbitraryListDepth";
import { remarkYamlMatter } from "./frontmatter";
import { options, remarkTaskList, remarkUnwrapHtml } from "./parse";
import { remarkStrikethrough } from "./strikethrough";
import { mdastFromProseMirror } from "./stringify";

export const parsePage = async (
	md: string
): Promise<{ doc: JsonObject; metadata?: Record<string, unknown> }> => {
	const file = await unified()
		.use(remarkParse)
		.use(remarkStrikethrough)
		.use(remarkTaskList)
		.use(remarkArbitraryListDepth)
		.use(remarkUnwrapHtml)
		.use(remarkFrontmatter, ["yaml"])
		.use(remarkYamlMatter)
		.use(remarkProseMirror, options)
		.process(md);

	const pmDoc = file.result;
	const metadata = file.data.matter;
	return { metadata, doc: pmDoc.toJSON() };
};

export const serializePage = (node: PmNode, metadata?: Record<string, unknown>) => {
	const mdast = mdastFromProseMirror(node);
	if (metadata && Object.keys(metadata).length > 0) {
		// Insert the YAML as the first child of the root node
		mdast.children.unshift({ type: "yaml", value: stringify(metadata) } satisfies Yaml);
	}

	return unified()
		.use(remarkStrikethrough)
		.use(remarkArbitraryListDepth)
		.use(remarkStringify, {
			rule: "-",
		})
		.use(remarkFrontmatter, ["yaml"])
		.stringify(mdast);
};
